import React from 'react';
import _ from 'lodash';
import moment from 'moment-timezone';

import { api } from 'common';
import NoAppointments from '../NoAppointments';
import { Button } from '../../../Button';
import {
  MONTH_DAY_FORMAT,
  TIME_OF_DAY_FORMAT,
} from '../../../../utils/dateTime';

import styles from './index.module.css';

interface Props {
  availableEhrTimeSlots: api.EhrTimeSlot.EhrTimeSlot[];
  onSlotSelected: (slot: api.EhrTimeSlot.EhrTimeSlot) => void;
  pending?: boolean;
  timezone?: string;
}

export const ScheduleAppointmentSectionView: React.FC<Props> = ({
  availableEhrTimeSlots,
  timezone,
  onSlotSelected,
  pending,
}) => {
  if (!availableEhrTimeSlots.length) {
    return <NoAppointments className={styles.NoAppointmentContainer} />;
  }
  const dayGroup = _.groupBy(availableEhrTimeSlots, (slot) => {
    return timezone
      ? moment(slot.startTime).tz(timezone).startOf('day').format()
      : moment(slot.startTime).startOf('day').format();
  });
  return (
    <>
      {Object.keys(dayGroup).map((dayTime) => {
        return (
          <div key={dayTime}>
            <div className={styles.TimeInfo}>
              {timezone
                ? moment(dayTime).tz(timezone).format(MONTH_DAY_FORMAT)
                : moment(dayTime).format(MONTH_DAY_FORMAT)}
            </div>
            <div className={styles.RenderAppointmentDisplay}>
              {dayGroup[dayTime].map((slot) => (
                <Button
                  key={slot.id}
                  className={styles.AppointmentButton}
                  onClick={() => onSlotSelected(slot)}
                  children={
                    timezone
                      ? moment(slot.startTime)
                          .tz(timezone)
                          .format(TIME_OF_DAY_FORMAT)
                      : moment(slot.startTime).format(TIME_OF_DAY_FORMAT)
                  }
                  disabled={pending}
                />
              ))}
            </div>
          </div>
        );
      })}
    </>
  );
};
